import apiempresaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    filtroSistema: 'Todos',
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('cliente', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    async create(_, dados) {
      const [{ data }] = await Promise.all([
        apiempresaweb.post('cliente', dados),
      ]);

      return data;
    },

    async createComValidacao(_, dados) {
      const [{ data }] = await Promise.all([
        apiempresaweb.post('cliente/validacao', dados),
      ]);

      return data;
    },

    // Cria cliente + controle de acesso atomicamente (transação no servidor).
    // Se o código já existir, o servidor retorna a entidade existente sem criar nada.
    async createCompleto(_, dados) {
      const [{ data }] = await Promise.all([
        apiempresaweb.post('cliente/completo', dados),
      ]);

      return data;
    },

    // Idem, porém sem checar duplicidade (usuário confirmou prosseguir).
    async createCompletoForcado(_, dados) {
      const [{ data }] = await Promise.all([
        apiempresaweb.post('cliente/completo/forcar', dados),
      ]);

      return data;
    },

    async update(_, dados) {
      const [{ data }] = await Promise.all([
        apiempresaweb.put(`cliente/${dados.id}`, dados),
      ]);

      return data;
    },

    async findOrdenado(_, { options }) {
      const data = await Promise.all([
        apiempresaweb.get('cliente/ordenado', { params: options }),
      ]);

      return data[0].data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_FILTRO(state, filtro) {
      state.filtroSistema = filtro;
    },
  },
};
